import axios from 'axios';
import { BaseAPI } from './BaseAPI';
export class StorageAPI extends BaseAPI {
  //刪除我的申請暫存
  async getStorage(accountId, companyType, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/myApplication/draft/${accountId}/${companyType}`
    );
    return data;
  }

  //刪除我的申請暫存
  async deleteStorage(accountId, companyType, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/myApplication/delete/draft/${accountId}/${companyType}`
    );
    return data;
  }
}

export default new StorageAPI({
  prefix: '',
  path: '/mo/application',
});
